import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

@Injectable({
    providedIn: 'root'
})
export class VisitorManagementAdminGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private roleService: RoleService,
    ) {
    }

    canActivate(): boolean {
        const userInfo = this.auth.getCurrentUserInfo();
        const groups = userInfo?.role;

        if (this.auth.isSuperUser() || this.roleService.isAdmin(groups)) {
            return true;
        }

        this.router.navigate([this.roleService.getDefaultRoute(groups)]);
        return false;
    }
}
